import { UserType } from "../../types/User";
import { put } from "../../utils/axios-config";
import { USERS } from "../../utils/constants";

export const updateUser = async (data: UserType) => await put<UserType, string>(USERS, data);